<template>
  <v-container fluid class="profil">
    <div class="top-icons w-100 px-0">
      <v-btn
        icon
        large
        color="primary"
        class="back-btn"
        @click="$goBackTo({ name: 'Fooldal' })"
      >
        <i class="fas fa-chevron-left"></i>
      </v-btn>
      <k-hamburger-icon
        class="back-btn ml-auto"
        v-if="isMobile"
      ></k-hamburger-icon>
    </div>
    <div class="page-content pt-8">
      <div class="flex-center-between mb-5">
        <div>
          <h2>{{ form.Nev || 'Profil' }}</h2>
        </div>
        <v-img
          max-height="86px"
          max-width="86px"
          height="86px"
          width="86px"
          :src="form.Fenykep ? form.Fenykep : $placeholderImage"
          class="rounded"
        >
          <file-select
            class="icon-holder success"
            accept="image/*"
            @input="OnImageSelect($event[0])"
          >
            <i class="fas fa-cog white--text"></i>
          </file-select>
        </v-img>
      </div>
      <div v-if="!formLoading">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            :label="nyelvesites['input_telefonszam_text']"
            v-model="form.Telefonszam"
            :rules="validations.Telefonszam"
          ></v-text-field>
          <v-text-field
            :label="nyelvesites['input_nev_text']"
            v-model="form.Nev"
            :rules="validations.Nev"
          ></v-text-field>
          <v-text-field
            :label="nyelvesites['input_email_text']"
            type="email"
            v-model="form.EmailCim"
            :rules="validations.EmailCim"
          ></v-text-field>
          <v-text-field
            :label="nyelvesites['input_hadrendi_szam_text']"
            v-model="form.HadrendiSzam"
            type="number"
            :rules="validations.HadrendiSzam"
          ></v-text-field>
          <k-autocomplete
            v-model="form.Szervezet"
            :rules="validations.Szervezet"
            :items="szervezetek"
            :label="nyelvesites['input_szervezet_text']"
          ></k-autocomplete>
          <v-text-field
            v-model="form.Jelszo"
            :rules="validations.Jelszo"
            type="password"
            :label="nyelvesites['input_jelszo_text']"
          ></v-text-field>
          <v-text-field
            :key="form.Jelszo"
            v-model="form.Jelszo2"
            :rules="validations.Jelszo2"
            type="password"
            :label="nyelvesites['input_jelszo_meg_egyszer_text']"
          ></v-text-field>
          <v-btn
            color="success"
            block
            large
            class="py-2 my-2"
            :loading="mentesLoading"
            @click="ProfilModositas"
          >
            Módosítás kész
          </v-btn>
          <!-- <v-btn
            text
            block
            large
            class="success--text text-decoration-underline"
            @click="Logout"
          >
            Kijelentkezés
          </v-btn> -->
        </v-form>
        <img
          v-if="isBv"
          src="../assets/images/bv-logo-zold.png"
          class="bv-logo-green"
        />
      </div>
      <div v-else>
        <k-profil-skeleton></k-profil-skeleton>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { NotificationFunctions } from '../functions/NotificationFunctions';
import { userService } from '../services/UserService';
import settings from '../settings';
import { AppStoreTypes } from '../store/modules/app';
import { GetBase64UrlFromFile } from '../utils/common';
import {
  scrollToError,
  vEmail,
  vMinLength,
  vNumberLetterSpaceOnly,
  vNumberOnly,
  vRequired,
  vSameValue,
  vTelephone,
} from '../utils/vuetifyFormRules';

export default {
  name: 'Profil',
  data() {
    return {
      valid: false,
      form: null,
      formLoading: false,
      mentesLoading: false,
      isBv: settings.env == 'bv',
    };
  },
  mounted() {},
  created() {
    this.CreateForm();
    this.LoadForm();
  },
  methods: {
    CreateForm(form) {
      let defaultForm = {
        Telefonszam: '',
        Nev: '',
        Fenykep: this.$placeholderImage,
        HadrendiSzam: '',
        Email: '',
        Szervezet: null,
        Jelszo: '',
        Jelszo2: '',
      };
      this.form = { ...defaultForm, ...(form ?? {}) };
    },
    async LoadForm() {
      this.formLoading = true;
      try {
        let result = await userService.GetProfil();
        this.CreateForm(result);
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.formLoading = false;
    },
    async ProfilModositas() {
      if (!this.$refs.form.validate()) {
        console.log(this.form);
        scrollToError(this);
        return;
      }
      this.mentesLoading = true;
      try {
        let form = { ...this.form };
        let response = await userService.SaveProfilModositasa({ form });
        NotificationFunctions.SuccessAlert('Profil', 'Mentés sikeres');
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.mentesLoading = false;
      await userService.GetUser();
      this.LoadForm();
    },
    async OnImageSelect(file) {
      let src = await GetBase64UrlFromFile(file);
      this.$set(this.form, 'Fenykep', src);
    },
    async Logout() {
      if (global.SNJS && global.SNJS.logout) {
        global.SNJS.logout();
      }
      await userService.Embed({ projektId: this.aktualisProjekt.Id, isTokenSet: false });
      if (this.$route.name != 'Fooldal') {
        this.$router.push({ name: 'Fooldal' });
      }
    },
  },
  computed: {
    ...mapGetters({
      szervezetek: AppStoreTypes.szervezetek.getAll,
      user: AppStoreTypes.user.get,
    }),
    validations() {
      return {
        Nev: [vRequired(), vNumberLetterSpaceOnly()],
        EmailCim: [vRequired(), vEmail()],
        Szervezet: [vRequired()],
        HadrendiSzam: [vRequired(), vNumberOnly()],
        Telefonszam: [vTelephone()],
        Jelszo: [vMinLength(8, 'Adjon meg legalább 8 karaktert')],
        Jelszo2: [vSameValue(this.form.Jelszo)],
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
